module.exports = __webpack_public_path__ + "static/media/04062021_arrow_right_140px.c6484b1c.svg";